import React from 'react';

import { NotFoundPic } from '../Icons/NotFound';

import styles from './not-found.module.scss';

export const NotFound = () => {
  return (
    <div className={styles.wrapper}>
      <NotFoundPic />
      <div className={styles.title}>Ничего не найдено :(</div>
      <div className={styles.text}>К сожалению, по вашим параметрам ничего не найдено, попробуйте изменить их</div>
    </div>
  );
};
